import accordion from "./components/accordion.js";
import alert from "./components/alert.js";
// import autocomplete from "./components/autocomplete.js";
// import appBar from "./components/appBar.js";
// import avatar from "./components/avatar.js";
import avatarGroupTheme from "./components/avatarGroup.js";
import badge from "./components/badge.js";
// import bottomNavigation from "./components/bottomNavigation.js";
import breadcrumbs from "./components/breadcrumbs.js";
import button from "./components/button.js";
import buttonGroup from "./components/buttonGroup.js";
// import card from "./components/card.js";
import checkbox from "./components/checkbox.js";
import chipTheme from "./components/chip.js";
import container from "./components/container.js";
// import cssBaseline from "./components/cssBaseline.js";
import dataGrid from "./components/dataGrid.js";
import datePicker from "./components/datePicker.js";
import dialog from "./components/dialog.js";
// import drawer from "./components/drawer.js";
// import fab from "./components/fab.js";
// import fade from "./components/fade.js";
// import filledInput from "./components/filledInput.js";
import formControl from "./components/formControl.js";
// import formGroup from "./components/formGroup.js";
// import formLabel from "./components/formLabel.js";
// import grid from "./components/grid.js";
// import grow from "./components/grow.js";
// import hidden from "./components/hidden.js";
// import icon from "./components/icon.js";
// import imageList from "./components/imageList.js";
import input from "./components/input.js";
import link from "./components/link.js";
import list from "./components/list.js";
import loadingIndicator from "./components/loadingIndicator.js";
import menu from "./components/menu.js";
// import mobileStepper from "./components/mobileStepper.js";
// import modal from "./components/modal.js";
// import nativeSelect from "./components/nativeSelect.js";
// import noSsr from "./components/noSsr.js";
import pagination from "./components/pagination.js";
// import paper from "./components/paper.js";
// import popover from "./components/popover.js";
// import portal from "./components/portal.js";
import radioButton from "./components/radioButton.js";
// import rating from "./components/rating.js";
// import scopedCssBaseline from "./components/scopedCssBaseline.js";
import select from "./components/select.js";
import sideSheet from "./components/sideSheet.js";
// import skeleton from "./components/skeleton.js";
// import slide from "./components/slide.js";
import slider from "./components/slider.js";
import snackbar from "./components/snackbar.js";
// import speedDial from "./components/speedDial.js";
// import stack from "./components/stack.js";
import stepper from "./components/stepper.js";
// import svgIcon from "./components/svgIcon.js";
// import swipeableDrawer from "./components/swipeableDrawer.js";
import switchTheme from "./components/switch.js";
import table from "./components/table.js";
import tabs from "./components/tabs.js";
// import textField from "./components/textField.js";
import toggleButton from "./components/toggleButton.js";
// import toolbar from "./components/toolbar.js";
import tooltip from "./components/tooltip.js";
// import typography from "./components/typography.js";
export const getLensThemeComponents = (tokens) => {
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, accordion(tokens)), alert(tokens)), avatarGroupTheme(tokens)), badge(tokens)), breadcrumbs(tokens)), button(tokens)), buttonGroup(tokens)), checkbox(tokens)), chipTheme(tokens)), loadingIndicator(tokens)), container(tokens)), dataGrid(tokens)), datePicker(tokens)), dialog(tokens)), formControl(tokens)), input(tokens)), link(tokens)), list(tokens)), menu(tokens)), pagination(tokens)), radioButton(tokens)), select(tokens)), sideSheet(tokens)), slider(tokens)), snackbar(tokens)), stepper(tokens)), switchTheme(tokens)), table(tokens)), tabs(tokens)), toggleButton(tokens)), tooltip(tokens));
};
//# sourceMappingURL=getLensThemeComponents.js.map